import React from "react";
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/slide3.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/slide4.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
        </Slider>
      </div>
    </>
  );
};

export default HomeSlider;
